import React, { useEffect } from 'react';

const ApprovalWorkflow = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: ApprovalWorkflow is not implemented yet.');
  }, []);
  return (
    <>
  { /*ApprovalWorkflow */} 
 </>
  );
};

export default ApprovalWorkflow;
